// src/pages/Customer/CustomerProfile.jsx
import React, { useEffect, useState } from "react";
import Layout from "../../layout/customer/Layout";
import CustomerBanner from "../../layout/customer/CustomerBanner";
import useProfileStore from "../../store/customer/useProfileStore";
import calculateCustomerProfileCompletion from "../../layout/customer/CustomerDetails/calculateCustomerProfileCompletion"; // Corrected path

const CustomerProfile = () => {
  const { profile, fetchProfile, isLoading } = useProfileStore(); // Added isLoading
  const [profileCompletion, setProfileCompletion] = useState(0);

  useEffect(() => {
    // Always fetch fresh profile on mount
    fetchProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (profile) {
      const completionPercentage = calculateCustomerProfileCompletion(profile);
      setProfileCompletion(completionPercentage);
    } else {
      setProfileCompletion(0); // Default to 0 if profile is null
    }
  }, [profile]);

  // While profile is loading and not yet available
  if (isLoading && !profile) {
    return (
      <div style={{ backgroundColor: "#E0E0E0", minHeight: "100vh" }}>
        <Layout>
          <div className="flex justify-center items-center h-full p-10">
            <div className="w-10 h-10 border-4 border-blue-500 border-dashed rounded-full animate-spin"></div>
            <p className="ml-3 text-gray-700">Loading profile...</p>
          </div>
        </Layout>
      </div>
    );
  }
  
  return (
    <div style={{ backgroundColor: "#E0E0E0" }}>
      <Layout>
        <div className="p-2">
          <CustomerBanner
            // coverImageUrl="/assets/Profile Bg.jpg" // Example cover, can be removed if not applicable
            profileImageUrl={profile?.profile_image || "/assets/placeholder-avatar.png"} // Use placeholder if no image
            name={profile?.name || "Customer"}
            role={"Customer"} // Static role for customer
            location={profile?.district || "N/A"} // Use district as location, or N/A
            progress={profileCompletion}
          />
        </div>
      </Layout>
    </div>
  );
};

export default CustomerProfile;